import Icon from "@ant-design/icons";

const OTPIconSVG = () => (
  <svg
    width="1.5em"
    height="1.5em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.7398 19.59H7.26978C6.47978 19.59 5.90977 19.56 5.41977 19.49C1.94977 19.11 1.25977 17.03 1.25977 13.58V7.26001C1.25977 3.81001 1.93977 1.72998 5.43977 1.34998C5.91977 1.27998 6.48978 1.25 7.26978 1.25H16.7398C17.5198 1.25 18.0898 1.27998 18.5898 1.34998C22.0698 1.72998 22.7498 3.81001 22.7498 7.26001V13.58C22.7498 17.03 22.0698 19.11 18.5698 19.49C18.0998 19.56 17.5298 19.59 16.7398 19.59ZM7.25977 2.75C6.54977 2.75 6.03977 2.78003 5.61977 2.84003C3.45977 3.08003 2.74977 3.75002 2.74977 7.27002V13.59C2.74977 17.1 3.45978 17.78 5.59978 18.01C6.03978 18.07 6.54978 18.1 7.26978 18.1H16.7398C17.4598 18.1 17.9598 18.07 18.3798 18.01C20.5398 17.77 21.2498 17.1 21.2498 13.58V7.26001C21.2498 3.75001 20.5398 3.07003 18.3998 2.84003C17.9498 2.78003 17.4498 2.75 16.7298 2.75H7.25977Z"
      fill="currentColor"
    />
    <path
      d="M17.2601 9.07007H13.5801C13.1701 9.07007 12.8301 8.73007 12.8301 8.32007C12.8301 7.91007 13.1701 7.57007 13.5801 7.57007H17.2601C17.6701 7.57007 18.0101 7.91007 18.0101 8.32007C18.0101 8.73007 17.6801 9.07007 17.2601 9.07007Z"
      fill="currentColor"
    />
    <path
      d="M10 9.32007C9.45 9.32007 9 8.87007 9 8.32007C9 7.77007 9.44 7.32007 10 7.32007C10.55 7.32007 11 7.77007 11 8.32007C11 8.87007 10.56 9.32007 10 9.32007Z"
      fill="currentColor"
    />
    <path
      d="M6.8501 9.32007C6.3001 9.32007 5.8501 8.87007 5.8501 8.32007C5.8501 7.77007 6.2901 7.32007 6.8501 7.32007H6.86009C7.41009 7.32007 7.86009 7.77007 7.86009 8.32007C7.86009 8.87007 7.4001 9.32007 6.8501 9.32007Z"
      fill="currentColor"
    />
    <path
      d="M17.2602 14.86H6.75023C6.34023 14.86 5.99023 14.52 5.99023 14.11C5.99023 13.7 6.32022 13.36 6.73022 13.36H17.2602C17.6702 13.36 18.0102 13.7 18.0102 14.11C18.0102 14.52 17.6802 14.86 17.2602 14.86Z"
      fill="currentColor"
    />
    <path
      d="M17 22.75H7C6.59 22.75 6.25 22.41 6.25 22C6.25 21.59 6.59 21.25 7 21.25H17C17.41 21.25 17.75 21.59 17.75 22C17.75 22.41 17.41 22.75 17 22.75Z"
      fill="currentColor"
    />
  </svg>
);
const OTPIcon = (props) => <Icon component={OTPIconSVG} {...props} />;

export default OTPIcon;
